import React, { useState, useRef, useEffect } from "react";
import {
    AlignLeftOutlined,
    AlignCenterOutlined,
    AlignRightOutlined,
    MenuOutlined,
} from "@ant-design/icons";
import { getHeroIcon } from "../../_helpers/heroicons";
import styles from "../styles/QurealRichEditor.module.css";

const AlignmentDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Get current alignment
    const getCurrentAlignment = () => {
        if (editor.isActive({ textAlign: "left" })) return "left";
        if (editor.isActive({ textAlign: "center" })) return "center";
        if (editor.isActive({ textAlign: "right" })) return "right";
        if (editor.isActive({ textAlign: "justify" })) return "justify";
        return "left"; // Default alignment
    };

    const currentAlignment = getCurrentAlignment();

    // Get appropriate icon for current alignment
    const getCurrentIcon = () => {
        switch (currentAlignment) {
            case "center":
                return <AlignCenterOutlined />;
            case "right":
                return <AlignRightOutlined />;
            case "justify":
                return <MenuOutlined />;
            default:
                return <AlignLeftOutlined />;
        }
    };

    // Apply text alignment
    const applyAlignment = (alignment) => {
        editor.chain().focus().setTextAlign(alignment).run();
        setIsOpen(false);
    };

    // Unset text alignment (back to default)
    const unsetAlignment = () => {
        editor.chain().focus().unsetTextAlign().run();
        setIsOpen(false);
    };

    return (
        <div className={styles.dropdown} ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.button} ${styles.dropdownToggle} ${
                    currentAlignment !== "left" ? styles.isActive : ""
                }`}
                title="Text alignment"
            >
                <span className={styles.dropdownLabel}>{getCurrentIcon()}</span>
                {getHeroIcon("chevron-down", { width: "12px" })}
            </button>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <div className={styles.alignGrid}>
                        <button
                            onClick={() => applyAlignment("left")}
                            className={`${styles.dropdownItem} ${
                                currentAlignment === "left"
                                    ? styles.dropdownItemActive
                                    : ""
                            }`}
                        >
                            <AlignLeftOutlined />
                        </button>

                        <button
                            onClick={() => applyAlignment("center")}
                            className={`${styles.dropdownItem} ${
                                currentAlignment === "center"
                                    ? styles.dropdownItemActive
                                    : ""
                            }`}
                        >
                            <AlignCenterOutlined />
                        </button>

                        <button
                            onClick={() => applyAlignment("right")}
                            className={`${styles.dropdownItem} ${
                                currentAlignment === "right"
                                    ? styles.dropdownItemActive
                                    : ""
                            }`}
                        >
                            <AlignRightOutlined />
                        </button>

                        <button
                            onClick={() => applyAlignment("justify")}
                            className={`${styles.dropdownItem} ${
                                currentAlignment === "justify"
                                    ? styles.dropdownItemActive
                                    : ""
                            }`}
                        >
                            <MenuOutlined />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AlignmentDropdown;
